/* STL footer — the subscribe panel.

   Deliberately NOT Madrid's <menu-drawer>: that class binds a close handler to
   every <button> inside itself (see stl-mobile-menu.js), which would kill the
   SIGN UP submit. This panel is small enough to own its open/close outright. */
(function () {
  'use strict';

  var LOCK = 'stl-subscribe-open';
  /* More than one control opens the panel (the footer's Join mailing list and the
     PDP USP row's Sign up), so focus returns to whichever was used. */
  var lastOpener = null;

  function panel() { return document.querySelector('[data-stl-subscribe]'); }

  function open() {
    var p = panel();
    if (!p) return;
    p.removeAttribute('hidden');
    /* Force a reflow so the transition has a from-state, rather than waiting a
       frame. `hidden` -> visible -> class in one task would otherwise collapse
       into a single style recalc and the panel would appear instead of sliding.

       DELIBERATELY NOT requestAnimationFrame: rAF is suspended in a hidden tab
       (already recorded for the collection counter), so a double-rAF version
       measured as never opening at all. Reading offsetWidth flushes layout
       synchronously and depends on nothing. */
    void p.offsetWidth;
    p.classList.add('is-open');
    document.body.classList.add(LOCK);
    var field = p.querySelector('.stl-subscribe__input');
    if (field) field.focus();
  }

  function close() {
    var p = panel();
    if (!p || p.hasAttribute('hidden')) return;
    p.classList.remove('is-open');
    document.body.classList.remove(LOCK);
    var trigger = lastOpener || document.querySelector('[data-stl-subscribe-open]');
    if (trigger && trigger.focus) trigger.focus({ preventScroll: true });
    // Match the CSS duration, then take it out of the tab order for good.
    setTimeout(function () {
      if (!p.classList.contains('is-open')) p.setAttribute('hidden', '');
    }, 350);
  }

  /* --- mobile accordions ------------------------------------------------
     Toteme collapse each footer column below the breakpoint. The lists are
     hidden/shown from JS rather than by CSS, because `[hidden]` has to be
     REMOVED on desktop — leaving a collapsed list hidden and relying on a CSS
     override would strand it hidden for anyone who resizes, which is exactly
     the class of bug the mobile drawer's scroll lock already produced. */
  var MOBILE = '(max-width: 989px)';

  function isMobile() { return window.matchMedia(MOBILE).matches; }

  /* Both pop-ups built on <details> — the footer's currency switcher and the
     cart's payment options — share this. Widened to `[data-stl-modal]` rather
     than writing a second copy when the cart one arrived; the region keeps its
     own attribute so nothing that already worked had to be re-tested.

     Focus goes back to the summary that opened it: a <details> closed from a
     control inside itself otherwise strands focus on a hidden element. */
  var MODALS = '[data-stl-region][open], [data-stl-modal][open]';

  function closeRegion() {
    var d = document.querySelector(MODALS);
    if (!d) return;
    d.removeAttribute('open');
    var summary = d.querySelector('summary');
    if (summary) summary.focus();
  }

  function setCol(toggle, open) {
    var list = toggle.parentElement.querySelector('.stl-footer__list');
    if (!list) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) list.removeAttribute('hidden');
    else list.setAttribute('hidden', '');
  }

  function syncColumns() {
    var mobile = isMobile();
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-stl-footer-toggle]'),
      function (toggle) {
        // Desktop is always open; mobile starts collapsed, and a column the
        // visitor opened stays open until they cross the breakpoint again.
        if (!mobile) setCol(toggle, true);
        else if (!toggle.dataset.stlTouched) setCol(toggle, false);
      }
    );
  }

  var colTimer;
  function onColResize() {
    clearTimeout(colTimer);
    colTimer = setTimeout(function () {
      Array.prototype.forEach.call(
        document.querySelectorAll('[data-stl-footer-toggle]'),
        function (t) { delete t.dataset.stlTouched; }
      );
      syncColumns();
    }, 150);
  }

  function init() {
    if (document.documentElement.dataset.stlFooter) return;
    document.documentElement.dataset.stlFooter = '1';

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-stl-subscribe-open]');
      if (opener) { e.preventDefault(); lastOpener = opener; open(); return; }
      if (e.target.closest('[data-stl-subscribe-close]')) { e.preventDefault(); close(); return; }
      /* The currency pop-up is a <details>, so opening and closing it are the
         browser's. These are the two things a <details> cannot do for itself:
         close on the scrim and close on the X. Escape is below. */
      if (e.target.closest('[data-stl-region-close], [data-stl-modal-close]')) {
        e.preventDefault();
        closeRegion();
        return;
      }
      var toggle = e.target.closest('[data-stl-footer-toggle]');
      if (toggle && isMobile()) {
        toggle.dataset.stlTouched = '1';
        setCol(toggle, toggle.getAttribute('aria-expanded') !== 'true');
      }
    });

    syncColumns();
    window.addEventListener('resize', onColResize);

    document.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape') return;
      /* The region panel sits ON TOP of everything, so it takes Escape first;
         otherwise one keypress would close the subscribe panel underneath it. */
      var region = document.querySelector(MODALS);
      if (region) { closeRegion(); return; }
      close();
    });

    /* Reopen on a failed or successful submit. The native customer form does a
       full page POST, so the panel would otherwise close itself on the reload
       and the visitor would never see the confirmation or the error. */
    var p = panel();
    if (p && p.querySelector('.stl-subscribe__note')) open();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    delete document.documentElement.dataset.stlFooter;
    init();
  });
})();
